'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _jsFileDownload = require('js-file-download');

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _questions = require('../actions/questions');

var _api = require('../api');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchQuestions),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchQuestion),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(editQuestion),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(changeFilter),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchFilterSubjectsOptions),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchFilterClausesOptions),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(addQuestionsToObjectives),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(generateQuestionsSlides),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(fetchDisciplineLegalBriefs),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(createQuestions),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(validateQuestions),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(validateOabPhase2),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(createOabPhase2),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(fetchQuestionsRequest),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(fetchQuestionRequest),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(editQuestionRequest),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(changeFilterObserver),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(fetchFilterSubjectsRequest),
    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(fetchFilterClausesRequest),
    _marked20 = /*#__PURE__*/regeneratorRuntime.mark(addQuestionsToObjectivesRequest),
    _marked21 = /*#__PURE__*/regeneratorRuntime.mark(generateQuestionsSlidesRequest),
    _marked22 = /*#__PURE__*/regeneratorRuntime.mark(fetchDisciplineLegalBriefsRequest),
    _marked23 = /*#__PURE__*/regeneratorRuntime.mark(createQuestionsRequest),
    _marked24 = /*#__PURE__*/regeneratorRuntime.mark(validateQuestionsRequest),
    _marked25 = /*#__PURE__*/regeneratorRuntime.mark(validateOabPhase2Request),
    _marked26 = /*#__PURE__*/regeneratorRuntime.mark(createOabPhase2Request);

var getQuestionsFilter = function getQuestionsFilter(state) {
    return state.questions.filter;
};

function fetchQuestions() {
    var filter, filterOptions, getParams, requestPath, response;
    return regeneratorRuntime.wrap(function fetchQuestions$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.select)(getQuestionsFilter);

                case 3:
                    filter = _context.sent;
                    filterOptions = [];


                    Object.keys(filter).forEach(function (filterKey) {
                        var value = filter[filterKey];
                        if (!Array.isArray(value) && value || value.length > 0 && value[0]) {
                            filterOptions.push({ key: filterKey, value: value });
                        }
                    });

                    if (!(filterOptions.length === 0)) {
                        _context.next = 10;
                        break;
                    }

                    _context.next = 9;
                    return (0, _effects.put)(_questions.actionCreators.fetchQuestionsFailed('Escolha um filtro'));

                case 9:
                    return _context.abrupt('return', _context.sent);

                case 10:
                    getParams = filterOptions.map(function (_ref) {
                        var key = _ref.key,
                            value = _ref.value;
                        return 'filter[' + key + ']=' + value;
                    });
                    requestPath = void 0;

                    if (getParams.length > 0) {
                        requestPath = '/questions?' + getParams.join('&');
                    } else {
                        requestPath = '/questions';
                    }

                    _context.next = 15;
                    return (0, _effects.call)(_api.request, 'get', requestPath);

                case 15:
                    response = _context.sent;
                    _context.next = 18;
                    return (0, _effects.put)(_questions.actionCreators.fetchQuestionsSucceeded(response.data));

                case 18:
                    _context.next = 24;
                    break;

                case 20:
                    _context.prev = 20;
                    _context.t0 = _context['catch'](0);
                    _context.next = 24;
                    return (0, _effects.put)(_questions.actionCreators.fetchQuestionsFailed('Ocorreu um erro na busca de questões'));

                case 24:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 20]]);
}

function fetchQuestion(_ref2) {
    var questionId = _ref2.questionId;
    var response;
    return regeneratorRuntime.wrap(function fetchQuestion$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/questions/' + questionId);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_questions.actionCreators.fetchQuestionSucceeded(response.data));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)(_questions.actionCreators.fetchQuestionFailed());

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function editQuestion(_ref3) {
    var questionId = _ref3.questionId,
        changes = _ref3.changes,
        redirect = _ref3.redirect;
    var response;
    return regeneratorRuntime.wrap(function editQuestion$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'patch', '/questions/' + questionId, changes);

                case 3:
                    response = _context3.sent;
                    _context3.next = 6;
                    return (0, _effects.put)(_questions.actionCreators.editQuestionSucceeded());

                case 6:
                    if (!redirect) {
                        _context3.next = 9;
                        break;
                    }

                    _context3.next = 9;
                    return (0, _effects.call)(redirect);

                case 9:
                    _context3.next = 15;
                    break;

                case 11:
                    _context3.prev = 11;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 15;
                    return (0, _effects.put)(_questions.actionCreators.editQuestionFailed());

                case 15:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 11]]);
}

function changeFilter(_ref4) {
    var key = _ref4.key,
        value = _ref4.value;
    return regeneratorRuntime.wrap(function changeFilter$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (!(key === 'disciplines')) {
                        _context4.next = 10;
                        break;
                    }

                    if (!(value && value.length > 0 && value[0].length > 0)) {
                        _context4.next = 6;
                        break;
                    }

                    _context4.next = 4;
                    return (0, _effects.put)(_questions.actionCreators.fetchFilterSubjectsRequest(value));

                case 4:
                    _context4.next = 8;
                    break;

                case 6:
                    _context4.next = 8;
                    return (0, _effects.put)(_questions.actionCreators.clearFilterSubjectsOptions());

                case 8:
                    _context4.next = 18;
                    break;

                case 10:
                    if (!(key === 'laws')) {
                        _context4.next = 18;
                        break;
                    }

                    if (!value) {
                        _context4.next = 16;
                        break;
                    }

                    _context4.next = 14;
                    return (0, _effects.put)(_questions.actionCreators.fetchFilterClausesRequest(value));

                case 14:
                    _context4.next = 18;
                    break;

                case 16:
                    _context4.next = 18;
                    return (0, _effects.put)(_questions.actionCreators.clearFilterClausesOptions());

                case 18:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function fetchFilterSubjectsOptions(_ref5) {
    var disciplinesIds = _ref5.disciplinesIds;
    var response;
    return regeneratorRuntime.wrap(function fetchFilterSubjectsOptions$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.prev = 0;
                    _context5.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/subjects?disciplines=' + disciplinesIds.join(','));

                case 3:
                    response = _context5.sent;
                    _context5.next = 6;
                    return (0, _effects.put)(_questions.actionCreators.fetchFilterSubjectsSucceeded(response.data));

                case 6:
                    _context5.next = 12;
                    break;

                case 8:
                    _context5.prev = 8;
                    _context5.t0 = _context5['catch'](0);
                    _context5.next = 12;
                    return (0, _effects.put)(_questions.actionCreators.fetchFilterSubjectsFailed());

                case 12:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this, [[0, 8]]);
}

function fetchFilterClausesOptions(_ref6) {
    var lawId = _ref6.lawId;
    var response;
    return regeneratorRuntime.wrap(function fetchFilterClausesOptions$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.prev = 0;
                    _context6.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/clauses?lawId=' + lawId);

                case 3:
                    response = _context6.sent;
                    _context6.next = 6;
                    return (0, _effects.put)(_questions.actionCreators.fetchFilterClausesSucceeded(response.data));

                case 6:
                    _context6.next = 12;
                    break;

                case 8:
                    _context6.prev = 8;
                    _context6.t0 = _context6['catch'](0);
                    _context6.next = 12;
                    return (0, _effects.put)(_questions.actionCreators.fetchFilterClausesFailed());

                case 12:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this, [[0, 8]]);
}

function addQuestionsToObjectives(_ref7) {
    var objectivesToAddQuestions = _ref7.objectivesToAddQuestions,
        questionsToAddOnObjective = _ref7.questionsToAddOnObjective;
    return regeneratorRuntime.wrap(function addQuestionsToObjectives$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.prev = 0;
                    _context7.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/objectives/relationships/questions/', {
                        objectives: objectivesToAddQuestions,
                        questions: questionsToAddOnObjective
                    });

                case 3:
                    _context7.next = 5;
                    return (0, _effects.put)(_questions.actionCreators.addQuestionsToObjectiveSucceeded());

                case 5:
                    _context7.next = 11;
                    break;

                case 7:
                    _context7.prev = 7;
                    _context7.t0 = _context7['catch'](0);
                    _context7.next = 11;
                    return (0, _effects.put)(_questions.actionCreators.addQuestionsToObjectiveFailed());

                case 11:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this, [[0, 7]]);
}

function generateQuestionsSlides(_ref8) {
    var questionsToGenerateSlide = _ref8.questionsToGenerateSlide;
    var response;
    return regeneratorRuntime.wrap(function generateQuestionsSlides$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.prev = 0;
                    _context8.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/questions/ppt', {
                        questions: questionsToGenerateSlide
                    }, 'arraybuffer');

                case 3:
                    response = _context8.sent;


                    (0, _jsFileDownload2.default)(response.data, 'questoes.pptx');

                    _context8.next = 7;
                    return (0, _effects.put)(_questions.actionCreators.generateQuestionsSlidesSucceeded());

                case 7:
                    _context8.next = 13;
                    break;

                case 9:
                    _context8.prev = 9;
                    _context8.t0 = _context8['catch'](0);
                    _context8.next = 13;
                    return (0, _effects.put)(_questions.actionCreators.generateQuestionsSlidesFailed());

                case 13:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this, [[0, 9]]);
}

function fetchDisciplineLegalBriefs(_ref9) {
    var disciplineId = _ref9.disciplineId;
    var response, legalBriefs;
    return regeneratorRuntime.wrap(function fetchDisciplineLegalBriefs$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.prev = 0;
                    _context9.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/legalbriefs?disciplines=' + disciplineId);

                case 3:
                    response = _context9.sent;
                    legalBriefs = response.data.reduce(function (aggr, legalBrief) {

                        aggr[legalBrief.id] = legalBrief;
                        return aggr;
                    }, {});
                    _context9.next = 7;
                    return (0, _effects.put)(_questions.actionCreators.fetchDisciplineLegalBriefsSucceeded(legalBriefs));

                case 7:
                    _context9.next = 13;
                    break;

                case 9:
                    _context9.prev = 9;
                    _context9.t0 = _context9['catch'](0);
                    _context9.next = 13;
                    return (0, _effects.put)(_questions.actionCreators.fetchDisciplineLegalBriefsFailed());

                case 13:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this, [[0, 9]]);
}

function createQuestions(_ref10) {
    var questions = _ref10.questions;
    return regeneratorRuntime.wrap(function createQuestions$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.prev = 0;
                    _context10.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/questions/bulk', { data: questions });

                case 3:
                    _context10.next = 5;
                    return (0, _effects.put)(_questions.actionCreators.createQuestionsSucceeded());

                case 5:
                    _context10.next = 11;
                    break;

                case 7:
                    _context10.prev = 7;
                    _context10.t0 = _context10['catch'](0);
                    _context10.next = 11;
                    return (0, _effects.put)(_questions.actionCreators.createQuestionsFailed(_context10.t0));

                case 11:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this, [[0, 7]]);
}

function validateQuestions(_ref11) {
    var questions = _ref11.questions;
    var response;
    return regeneratorRuntime.wrap(function validateQuestions$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    _context11.prev = 0;
                    _context11.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/questions/validate', { data: questions });

                case 3:
                    response = _context11.sent;

                    if (!(response.data.data.data && response.data.data.data.length === 0)) {
                        _context11.next = 6;
                        break;
                    }

                    throw new Error('O servidor não retornou nenhuma questão. Possívelmente todas as questões já foram inseridas anteriormente.');

                case 6:
                    _context11.next = 8;
                    return (0, _effects.put)(_questions.actionCreators.validateQuestionsSucceeded(response.data.data));

                case 8:
                    _context11.next = 14;
                    break;

                case 10:
                    _context11.prev = 10;
                    _context11.t0 = _context11['catch'](0);
                    _context11.next = 14;
                    return (0, _effects.put)(_questions.actionCreators.validateQuestionsFailed(_context11.t0));

                case 14:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this, [[0, 10]]);
}

function validateOabPhase2(_ref12) {
    var data = _ref12.data,
        meta = _ref12.meta;
    var response;
    return regeneratorRuntime.wrap(function validateOabPhase2$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.prev = 0;
                    _context12.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/questions/oab-phase-2/validate', { data: data, meta: meta });

                case 3:
                    response = _context12.sent;
                    _context12.next = 6;
                    return (0, _effects.put)(_questions.actionCreators.validateOabPhase2Succeeded(response.data.questions, response.data.resolved));

                case 6:
                    _context12.next = 12;
                    break;

                case 8:
                    _context12.prev = 8;
                    _context12.t0 = _context12['catch'](0);
                    _context12.next = 12;
                    return (0, _effects.put)(_questions.actionCreators.validateOabPhase2Failed(_context12.t0));

                case 12:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this, [[0, 8]]);
}

function createOabPhase2(_ref13) {
    var questions = _ref13.questions,
        meta = _ref13.meta;
    return regeneratorRuntime.wrap(function createOabPhase2$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    _context13.prev = 0;
                    _context13.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/questions/oab-phase-2/bulk', { data: questions, meta: meta });

                case 3:
                    _context13.next = 5;
                    return (0, _effects.put)(_questions.actionCreators.createOabPhase2Succeeded());

                case 5:
                    _context13.next = 11;
                    break;

                case 7:
                    _context13.prev = 7;
                    _context13.t0 = _context13['catch'](0);
                    _context13.next = 11;
                    return (0, _effects.put)(_questions.actionCreators.createOabPhase2Failed(_context13.t0));

                case 11:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked13, this, [[0, 7]]);
}

function fetchQuestionsRequest() {
    return regeneratorRuntime.wrap(function fetchQuestionsRequest$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    _context14.next = 2;
                    return (0, _effects.takeLatest)(_questions.actionTypes.FETCH_QUESTIONS_REQUEST, fetchQuestions);

                case 2:
                case 'end':
                    return _context14.stop();
            }
        }
    }, _marked14, this);
}

function fetchQuestionRequest() {
    return regeneratorRuntime.wrap(function fetchQuestionRequest$(_context15) {
        while (1) {
            switch (_context15.prev = _context15.next) {
                case 0:
                    _context15.next = 2;
                    return (0, _effects.takeLatest)(_questions.actionTypes.FETCH_QUESTION_REQUEST, fetchQuestion);

                case 2:
                case 'end':
                    return _context15.stop();
            }
        }
    }, _marked15, this);
}

function editQuestionRequest() {
    return regeneratorRuntime.wrap(function editQuestionRequest$(_context16) {
        while (1) {
            switch (_context16.prev = _context16.next) {
                case 0:
                    _context16.next = 2;
                    return (0, _effects.takeLatest)(_questions.actionTypes.EDIT_QUESTION_REQUEST, editQuestion);

                case 2:
                case 'end':
                    return _context16.stop();
            }
        }
    }, _marked16, this);
}

function changeFilterObserver() {
    return regeneratorRuntime.wrap(function changeFilterObserver$(_context17) {
        while (1) {
            switch (_context17.prev = _context17.next) {
                case 0:
                    _context17.next = 2;
                    return (0, _effects.takeEvery)(_questions.actionTypes.CHANGE_FILTER, changeFilter);

                case 2:
                case 'end':
                    return _context17.stop();
            }
        }
    }, _marked17, this);
}

function fetchFilterSubjectsRequest() {
    return regeneratorRuntime.wrap(function fetchFilterSubjectsRequest$(_context18) {
        while (1) {
            switch (_context18.prev = _context18.next) {
                case 0:
                    _context18.next = 2;
                    return (0, _effects.takeEvery)(_questions.actionTypes.FETCH_FILTER_SUBJECTS_REQUEST, fetchFilterSubjectsOptions);

                case 2:
                case 'end':
                    return _context18.stop();
            }
        }
    }, _marked18, this);
}

function fetchFilterClausesRequest() {
    return regeneratorRuntime.wrap(function fetchFilterClausesRequest$(_context19) {
        while (1) {
            switch (_context19.prev = _context19.next) {
                case 0:
                    _context19.next = 2;
                    return (0, _effects.takeEvery)(_questions.actionTypes.FETCH_FILTER_CLAUSES_REQUEST, fetchFilterClausesOptions);

                case 2:
                case 'end':
                    return _context19.stop();
            }
        }
    }, _marked19, this);
}

function addQuestionsToObjectivesRequest() {
    return regeneratorRuntime.wrap(function addQuestionsToObjectivesRequest$(_context20) {
        while (1) {
            switch (_context20.prev = _context20.next) {
                case 0:
                    _context20.next = 2;
                    return (0, _effects.takeEvery)(_questions.actionTypes.ADD_QUESTIONS_TO_OBJECTIVE_REQUEST, addQuestionsToObjectives);

                case 2:
                case 'end':
                    return _context20.stop();
            }
        }
    }, _marked20, this);
}

function generateQuestionsSlidesRequest() {
    return regeneratorRuntime.wrap(function generateQuestionsSlidesRequest$(_context21) {
        while (1) {
            switch (_context21.prev = _context21.next) {
                case 0:
                    _context21.next = 2;
                    return (0, _effects.takeEvery)(_questions.actionTypes.GENERATE_QUESTIONS_SLIDES_REQUEST, generateQuestionsSlides);

                case 2:
                case 'end':
                    return _context21.stop();
            }
        }
    }, _marked21, this);
}

function fetchDisciplineLegalBriefsRequest() {
    return regeneratorRuntime.wrap(function fetchDisciplineLegalBriefsRequest$(_context22) {
        while (1) {
            switch (_context22.prev = _context22.next) {
                case 0:
                    _context22.next = 2;
                    return (0, _effects.takeLatest)(_questions.actionTypes.FETCH_DISCIPLINE_LEGAL_BRIEFS_REQUEST, fetchDisciplineLegalBriefs);

                case 2:
                case 'end':
                    return _context22.stop();
            }
        }
    }, _marked22, this);
}

function createQuestionsRequest() {
    return regeneratorRuntime.wrap(function createQuestionsRequest$(_context23) {
        while (1) {
            switch (_context23.prev = _context23.next) {
                case 0:
                    _context23.next = 2;
                    return (0, _effects.takeLatest)(_questions.actionTypes.CREATE_QUESTIONS_REQUEST, createQuestions);

                case 2:
                case 'end':
                    return _context23.stop();
            }
        }
    }, _marked23, this);
}

function validateQuestionsRequest() {
    return regeneratorRuntime.wrap(function validateQuestionsRequest$(_context24) {
        while (1) {
            switch (_context24.prev = _context24.next) {
                case 0:
                    _context24.next = 2;
                    return (0, _effects.takeLatest)(_questions.actionTypes.VALIDATE_QUESTIONS_REQUEST, validateQuestions);

                case 2:
                case 'end':
                    return _context24.stop();
            }
        }
    }, _marked24, this);
}

function validateOabPhase2Request() {
    return regeneratorRuntime.wrap(function validateOabPhase2Request$(_context25) {
        while (1) {
            switch (_context25.prev = _context25.next) {
                case 0:
                    _context25.next = 2;
                    return (0, _effects.takeLatest)(_questions.actionTypes.VALIDATE_OAB_PHASE_2_REQUEST, validateOabPhase2);

                case 2:
                case 'end':
                    return _context25.stop();
            }
        }
    }, _marked25, this);
}

function createOabPhase2Request() {
    return regeneratorRuntime.wrap(function createOabPhase2Request$(_context26) {
        while (1) {
            switch (_context26.prev = _context26.next) {
                case 0:
                    _context26.next = 2;
                    return (0, _effects.takeLatest)(_questions.actionTypes.CREATE_OAB_PHASE_2_REQUEST, createOabPhase2);

                case 2:
                case 'end':
                    return _context26.stop();
            }
        }
    }, _marked26, this);
}

exports.default = [fetchQuestionsRequest, fetchQuestionRequest, editQuestionRequest, changeFilterObserver, fetchFilterSubjectsRequest, fetchFilterClausesRequest, addQuestionsToObjectivesRequest, generateQuestionsSlidesRequest, fetchDisciplineLegalBriefsRequest, createQuestionsRequest, validateQuestionsRequest, validateOabPhase2Request, createOabPhase2Request];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/questions.js
// module id = 2228
// module chunks = 0